import React from 'react';
import { Link } from 'react-router-dom';
import { useApp } from '../../context/AppContext';

const Footer = () => {
    const { settings } = useApp();

    return (
        <footer style={{ background: '#111', color: '#aaa', marginTop: '40px' }}>
            <div className="footer-top" style={{ maxWidth: '1280px', margin: 'auto', padding: '36px 20px', display: 'grid', gridTemplateColumns: '2fr 1fr 1fr 1fr', gap: '32px' }}>

                {/* ✅ Logo + Name Side by Side in Footer */}
                <div>
                    <div className="footer-logo" style={{ display: 'flex', alignItems: 'center', gap: '12px', marginBottom: '15px' }}>
                        <img
                            src="/logo.png"
                            alt="Wistar News"
                            style={{ height: '120px', width: 'auto', filter: 'brightness(0) invert(1)' }}
                            onError={(e) => e.target.style.display = 'none'}
                        />
                        <div>
                            <div style={{ fontFamily: 'var(--ff-label)', fontSize: '40px', color: '#fff' }}>
                                Wistar<span style={{ color: 'var(--red)' }}>News</span>
                            </div>
                            <div style={{ fontSize: '9px', color: '#888', letterSpacing: '1px' }}>
                                News That Matters
                            </div>
                        </div>
                    </div>
                    <p style={{ fontSize: '13px', lineHeight: '1.6', marginTop: '8px' }}>
                        {settings.footerAbout || 'Your trusted source for breaking news, in-depth analysis, and unbiased reporting from India and around the world.'}
                    </p>
                    <div style={{ marginTop: '14px', display: 'flex', gap: '10px' }}>
                        {settings.twitter && <a href={settings.twitter} target="_blank" rel="noopener noreferrer" style={{ background: 'var(--red)', color: '#fff', padding: '6px 14px', borderRadius: '3px', fontSize: '12px', fontWeight: '700', textDecoration: 'none' }}>𝕏 Twitter</a>}
                        {settings.facebook && <a href={settings.facebook} target="_blank" rel="noopener noreferrer" style={{ background: '#1877f2', color: '#fff', padding: '6px 14px', borderRadius: '3px', fontSize: '12px', fontWeight: '700', textDecoration: 'none' }}>Facebook</a>}
                        {settings.youtube && <a href={settings.youtube} target="_blank" rel="noopener noreferrer" style={{ background: '#ff0000', color: '#fff', padding: '6px 14px', borderRadius: '3px', fontSize: '12px', fontWeight: '700', textDecoration: 'none' }}>▶ YouTube</a>}
                    </div>
                </div>

                <div>
                    <h6 style={{ fontFamily: 'var(--ff-label)', fontSize: '16px', letterSpacing: '1px', color: '#fff', marginBottom: '14px' }}>Categories</h6>
                    <ul style={{ listStyle: 'none', padding: 0 }}>
                        <li><Link to="/category/india" style={{ color: '#999', fontSize: '13px', padding: '5px 0', display: 'block', textDecoration: 'none' }}>India</Link></li>
                        <li><Link to="/category/world" style={{ color: '#999', fontSize: '13px', padding: '5px 0', display: 'block', textDecoration: 'none' }}>World</Link></li>
                        <li><Link to="/category/politics" style={{ color: '#999', fontSize: '13px', padding: '5px 0', display: 'block', textDecoration: 'none' }}>Politics</Link></li>
                        <li><Link to="/category/business" style={{ color: '#999', fontSize: '13px', padding: '5px 0', display: 'block', textDecoration: 'none' }}>Business</Link></li>
                        <li><Link to="/category/sports" style={{ color: '#999', fontSize: '13px', padding: '5px 0', display: 'block', textDecoration: 'none' }}>Sports</Link></li>
                        <li><Link to="/category/entertainment" style={{ color: '#999', fontSize: '13px', padding: '5px 0', display: 'block', textDecoration: 'none' }}>Entertainment</Link></li>
                    </ul>
                </div>

                <div>
                    <h6 style={{ fontFamily: 'var(--ff-label)', fontSize: '16px', letterSpacing: '1px', color: '#fff', marginBottom: '14px' }}>Quick Links</h6>
                    <ul style={{ listStyle: 'none', padding: 0 }}>
                        <li><a href="#" style={{ color: '#999', fontSize: '13px', padding: '5px 0', display: 'block', textDecoration: 'none' }}>About Us</a></li>
                        <li><a href="#" style={{ color: '#999', fontSize: '13px', padding: '5px 0', display: 'block', textDecoration: 'none' }}>Contact</a></li>
                        <li><a href="#" style={{ color: '#999', fontSize: '13px', padding: '5px 0', display: 'block', textDecoration: 'none' }}>Advertise</a></li>
                        <li><a href="#" style={{ color: '#999', fontSize: '13px', padding: '5px 0', display: 'block', textDecoration: 'none' }}>Privacy Policy</a></li>
                        <li><Link to="/admin" style={{ color: '#999', fontSize: '13px', padding: '5px 0', display: 'block', textDecoration: 'none' }}>Admin Login</Link></li>
                    </ul>
                </div>

                <div>
                    <h6 style={{ fontFamily: 'var(--ff-label)', fontSize: '16px', letterSpacing: '1px', color: '#fff', marginBottom: '14px' }}>Newsletter</h6>
                    <p style={{ fontSize: '13px', marginBottom: '12px' }}>Get top news delivered to your inbox every morning.</p>
                    <input type="email" placeholder="your@email.com" style={{ width: '100%', padding: '8px 10px', border: 'none', borderRadius: '3px', fontSize: '13px', marginBottom: '8px' }} />
                    <button className="btn btn-red" style={{ width: '100%' }}>Subscribe →</button>
                </div>
            </div>
            <div className="footer-bot" style={{ background: '#000', textAlign: 'center', padding: '12px', fontSize: '12px', color: '#555' }}>
                © 2026 Wistar News. All rights reserved. | Powered by Wistar Media
            </div>
        </footer>
    );
};

export default Footer;